import { CaptureButton } from "@/components/CaptureButton";
import { CaptureStatus } from "@/components/CaptureStatus";
import { CountdownDisplay } from "@/components/CountdownDisplay";
import { PageTransition } from "@/components/PageTransition";
import { WebcamDisplay } from "@/components/WebcamDisplay";
import { useEffectOnce } from "@/hooks/useEffectOnce";
import { usePhotoCapture } from "@/hooks/usePhotoCapture";
import { useFrameStore } from "@/lib/store/frameStore";
import { usePaymentStore } from "@/lib/store/paymentStore";
import { useNavigate } from "react-router";
import { useSEO } from "@/lib/seo/useSEO";
import { AspectRatio } from "@/lib/model/Frame";

export const CameraPage: React.FC = () => {
  const { webCamRef, state, handleCapture } = usePhotoCapture();
  const navigate = useNavigate();
  const { paymentPayload } = usePaymentStore();
  const { frame } = useFrameStore();
  const imageCount = frame?.imagesCount || 0;

  useEffectOnce(() => {
    if (!paymentPayload) {
      navigate("/photo-booth");
    }
  })

  useSEO({
    title: "Capture Photos - Photo Booth Camera",
    description: "Capture your photos with the KeptScene photo booth. Use your camera to take photos that will be processed with effects.",
    keywords: "photo booth camera, capture photos, webcam, KeptScene camera",
    noindex: true,
  });

  return (
    <PageTransition>
      <div className="px-4 py-12 h-screen-safe-area">
        <div className="flex flex-col items-center">
          <h1 className="text-4xl text-vintage-red">Keptscene</h1>
        </div>
        
        <div className="flex justify-center mt-8">
        <WebcamDisplay 
          ref={webCamRef} 
          isFlashing={state.isFlashing} 
          countDownTime={state.countDownTime}
          isCapturing={state.isCapturing}
          aspectRatio={frame?.aspectRatio || AspectRatio.ONE_TO_ONE}
        />
        </div>
        
        {state.isCapturing ? (
          <CountdownDisplay
            countDownTime={state.countDownTime}
            captureCount={state.captureCount}
            totalPhotos={imageCount}
          />
        ) : (
          <CaptureStatus
            capturedImagesCount={state.capturedImages.length}
            isCapturing={state.isCapturing}
          />
        )}

        <div className="flex justify-center mt-8">
          <CaptureButton 
            onClick={handleCapture} 
            disabled={state.isCapturing || state.isUploadingPhoto} 
          />
        </div>
      </div>
    </PageTransition>
  );
};
